import { createSelector } from '@ngrx/store';

const selectReport = (state: any) => {
  return state.report;
};

export const selectShareReportSuccess = createSelector(
  selectReport,
  (state) => ({ message: state.message })
);

export const selectShareReportFailure = createSelector(
  selectReport,
  (state) => state.error
);

export const selectEditPromptLoading = createSelector(
  selectReport,
  (state) => state.promptUpdateLoading
);

export const selectEditPromptSuccess = createSelector(
  selectReport,
  (state) => state.promptUpdateSuccess
);

export const selectEditPromptFailure = createSelector(
  selectReport,
  (state) => state.promptUpdateError
);

export const selectRefineIcpScoreSuccess = createSelector(
  selectReport,
  (state) => state.result
);

export const selectRefineIcpScoreFailure = createSelector(
  selectReport,
  (state) => state.error
);

export const selectChangeCompany = createSelector(
  selectReport,
  (state) => state.promptUpdateError
);

export const selectChangeCompanySuccess = createSelector(
  selectReport,
  (state) => state.result || null // Ensure it never emits undefined
);

export const selectChangeCompanyFailure = createSelector(
  selectReport,
  (state) => state.error
);

export const selectCompany = createSelector(
  selectReport, // Ensure `selectReport` correctly selects the `report` slice
  (state) => state.company // Select the company property
);
